module.exports = __webpack_public_path__ + "img/inter-1.70c1b865.jpg";